import {useCSSVariables} from "../hooks/useCSSVariables";
import React, {Fragment, useEffect, useState} from "react";
import {RecipeDataHandler} from "../logic/db/RecipeDataHandler";
import {Svgs} from "../assets/svgs/Svgs";
import ListView from "../reusable/ListView/ListView";
import ListItem from "../reusable/ListView/ListItem";
import Center from "../reusable/Layouts/Center";
import RoundButton from "../reusable/Actions/RoundButton";
import {RoundLink} from "../reusable/Actions/RoundLink";
import {RecipeModel} from "../logic/models/RecipeModel";
import {TranslationParser} from "../translations/TranslationParser";
import {useTranslation} from "react-i18next";

export function RecipesListView() {
    const cssVars = useCSSVariables()
    const [recipes, setRecipes] = useState<RecipeModel[]>([])
    const {t} = useTranslation("common")

    useEffect(() => {
        RecipeDataHandler.getRecipes().then(result => {
            setRecipes((result as Recipe[]).map(recipe => new RecipeModel({recipe})));
        }).catch(reason => {
            console.log(reason)
        })
        RecipeDataHandler.registerIngredientListener((recipes) =>
            setRecipes(recipes.map(recipe => new RecipeModel({recipe}))))
    }, [])

    return (
        <div className="organisms-recipeslistview">
            { recipes.length > 0 ?
                <ListView>
                    {recipes.map(recipe => {
                        const listData = recipe.retrieveListData().filter(tag => tag.label === "mass" || tag.label === "diameter" || tag.label === "height")
                        const tags = TranslationParser.parseUnits(t, listData)
                        return <ListItem label={recipe.recipe.name} key={recipe.recipe.name}
                                      tags={tags}
                                      actions={<RecipeActions rec={recipe.recipe}/>}/>
                        }
                    )}
                </ListView> : null
            }
            <Center>
                <RoundLink iconSvg={<Svgs.PlusSvg color={cssVars.PositiveColor}/>} to="/recipes/add"/>
            </Center>
        </div>
    );
}

const RecipeActions = (props: {rec: Recipe}) => {
    const cssVars = useCSSVariables()
    const [recipe] = useState(props.rec)
    const onDelete = () => RecipeDataHandler.deleteRecipe(recipe)

    return (
        <Fragment>
            <RoundButton onMouseUp={onDelete} iconSvg={<Svgs.MinusSvg color={cssVars.NegativeColor}/>}/>
            <RoundLink iconSvg={<Svgs.EditSvg color={cssVars.DarkColor}/>} to={`/recipes/edit/${recipe.name}`}/>
            <RoundLink iconSvg={<Svgs.ConvertSvg/>} to={`/recipes/converter/${recipe.name}`}/>
        </Fragment>
    )
}
